import React from 'react';

import Alert from '.';

const SuccessAlert: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children = undefined,
  ...props
}) => (
  <Alert
    icon="images/global/icons/16/success.svg"
    iconTitle="Success"
    iconClassName="flex-shrink-0"
    colorClassName="bg-green-lightest text-green border-green-lighter"
    {...props}
  >
    {children}
  </Alert>
);

export default SuccessAlert;
